import baseColors from './baseColors'
import gradeColors from './gradeColors'
import subjectColors from './subjectColors'
import userColors from './userColors'

export default {
  ...baseColors,
  ...subjectColors,
  ...userColors,
  ...gradeColors,
  CREAM_BG: '#FEF4E1',
  EDUBOOK: '#FF6A00',
  EDUBOOK_LIGHT: '#FFF2DF',
  GRADIENT: `linear-gradient(90deg, ${baseColors.SECONDARY_700}, ${baseColors.ACCENT_600})`,
}
